import { DeliveryLocationScreen } from "../screens/reports/DeliveryLocationScreen";
import { SearchScreen } from "../screens/reports/SearchScreen";

export const ReportRoutes = [
  { path: "/reports/delivery", exact: true, component: DeliveryLocationScreen },
  { path: "/reports/search", exact: true, component: SearchScreen },
];
